import React, { useState, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { Box, Tooltip } from '@mui/material'

import { Logo, Moon, Sun } from 'assets/icons'
import { getStoredThemeMode, applyThemeMode } from 'apps/utils/themeMode'
import { Menu } from '../Menu'

export const SideNavigation = ( { isMenuShown } ) => {
	const history = useHistory()

	const [ themeMode, setThemeMode ] = useState( getStoredThemeMode )
	const toggleThemeMode = useCallback( () => {
		setThemeMode( prev => {
			const next = prev === 'dark' ? 'light' : 'dark'
			applyThemeMode( next )
			return next
		} )
	}, [] )

	const hoverSx = {
		cursor: 'var(--cursor-pointer)',
		transition: 'background-color 0.2s ease',
		'&:hover': { backgroundColor: 'var(--hover)' }
	}

	return (
		// In-flow placeholder keeps the 64px grid column; the panel itself is
		// fixed so it stays put on scroll (the page scrolls inside an
		// overflow:auto container, which breaks position:sticky).
		<Box width='64px'>
			<Box
				position='fixed'
				top='0'
				left='0'
				height='100vh'
				width='64px'
				zIndex='10'
				backgroundColor='var(--bg)'
				borderRight='1px solid var(--line)'
				display='flex'
				flexDirection='column'
				alignItems='center'
			>
				{ /* Logo doubles as a button back to the landing page */ }
				<Box
					onClick={ () => history.push( '/' ) }
					display='flex'
					alignItems='center'
					justifyContent='center'
					height='64px'
					width='100%'
					sx={ hoverSx }
				>
					<Logo width='30px' height='30px' />
				</Box>
				{ isMenuShown &&
					<Menu isLeftSide={ true } />
				}
				{ /* Theme toggle pinned to the bottom of the fixed panel */ }
				<Tooltip
					title={ themeMode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode' }
					placement='right'
					arrow
				>
					<Box
						onClick={ toggleThemeMode }
						role='button'
						className='theme-toggle'
						marginTop='auto'
						display='flex'
						alignItems='center'
						justifyContent='center'
						height='64px'
						width='100%'
						sx={ hoverSx }
					>
						{ themeMode === 'dark'
							? <Sun className='sun-icon' viewBox='0 0 26 26' width='30px' height='30px' />
							: <Moon className='moon-icon' viewBox='0 0 26 26' width='30px' height='30px' />
						}
					</Box>
				</Tooltip>
			</Box>
		</Box>
	)
}
